// desktopSnapshot.js
//
// Canonical Desktop-preset window layout, hand-dumped at the
// reference viewport. Replace SNAPSHOT_WINDOWS by pasting the
// verbatim JSON output of the "Dump Layout" button — do not
// hand-edit individual coords, do not strip the z field, do not
// reorder. The whole object is the contract.
//
// Non-reference viewports scale x/y/width/height proportionally
// from these coordinates (see applySnapshot in useFloatingWindows).

export const SNAPSHOT_VIEWPORT = { width: 1931, height: 1050 };

export const SNAPSHOT_TITLE_BAR_HEIGHT = 28;
export const SNAPSHOT_MIN_GRAB = 60;

// Hand-dumped layout at the reference viewport (1931x1050 on
// Michael's 1080p Windows desktop after DWM chrome). Replace by
// pasting the verbatim JSON output of "Dump Layout" — both the
// SNAPSHOT_VIEWPORT and the windows object move together.
export const SNAPSHOT_WINDOWS = {
    aiAdvisor:    { x:   13, y: 340, width: 400, height: 150, z: 266 },
    yourHotel:    { x:  561, y: 293, width: 350, height: 520, z: 276 },
    competitors:  { x: 1461, y: 300, width: 450, height: 520, z: 252 },
    action:       { x: 1082, y:   0, width: 690, height: 955, z: 250 },
    lodging:      { x: 1022, y: 495, width: 430, height: 190, z: 256 },
    research:     { x: 1018, y: 285, width: 430, height: 200, z: 254 },
    ghost:        { x: 1024, y: 693, width: 430, height: 210, z: 260 },
    orbitalRiver: { x:    3, y:   0, width: 1020, height: 290, z: 231 },
    // Activity feed window — the icon-led transcript + message feed
    // (ActivityFeed). Replaced the legacy ticker `activity` window.
    // z=290 sits above every other current panel; rebake via Dump
    // Layout once placed to taste.
    activity:     { x:   35, y: 766, width: 600, height: 280, z: 290 },
    // Seeded default for the new Insights window. Hand-placed (not
    // dumped) — drag it where you want and re-run Dump Layout to
    // bake the real coords into this object alongside the rest.
    insights:     { x:   11, y: 495, width: 430, height: 230, z: 268 },
    // Seeded default for the new standalone Scores window. Sits in
    // the gap between the left rail (aiAdvisor / insights) and the
    // right action stack (action / research / lodging / ghost). z
    // is just above aiAdvisor so it floats on overlap; drag and
    // Dump Layout to bake the real coords.
    scores:       { x:  445, y: 340, width: 380, height: 220, z: 270 },
};

